<template>
    <Layout>
        <MainPageLoader />
    </Layout>
</template>

<script>
    import Layout from '@layouts/main';
    import MainPageLoader from '@components/MainPageLoader';

    export default {
        /**
         * Custom page meta data property for the view components.
         *
         * @type {Object}
         */
        metaInfo: {
            title: 'Logout',
            meta: [
                {
                    name: 'description',
                    content: 'Logout',
                },
            ],
            // This is a placeholder to ensure proper canonical is set from specified SEO url
            // Full canonical URL including top level domain should be used
            link: [
                {
                    rel: 'canonical',
                    href: '/logout',
                },
            ],
        },

        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            Layout,
            MainPageLoader,
        },

        /**
         * This method logic will be run immediately after the Vue instance is created.
         *
         * @link https://vuejs.org/v2/guide/instance.html#Lifecycle-Diagram
         */
        created () {
            // Define the incoming state that redirected to the login view
            return this.$auth.check() ? this.$auth.logout({
                redirect: '/login',
            }) : this.$router.push('/login');
        },
    };
</script>
